// Campus photo for /colleges/university-of-pittsburgh: CC BY-SA 2.0, by Tony Webster, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ACathedral_of_Learning_blue_sky_cloud.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-pittsburgh/; credited under the photo.
const photo = {
    "slug": "university-of-pittsburgh",
    "alt": "The Cathedral of Learning rising above the trees against a clear blue sky at the University of Pittsburgh",
    "src": "/colleges/university-of-pittsburgh/campus-1600.webp",
    "srcSmall": "/colleges/university-of-pittsburgh/campus-800.webp",
    "srcMid": "/colleges/university-of-pittsburgh/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-pittsburgh/og.jpg",
    "title": "Cathedral of Learning blue sky cloud",
    "author": "Tony Webster",
    "license": "CC BY-SA 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ACathedral_of_Learning_blue_sky_cloud.jpg",
    "read": "2026-10-02"
};

export default photo;
